const TruncateName = (name, maxLength = 16) => {
  if (name.length <= maxLength) return name;
  const start = name.slice(0, 6);
  const end = name.slice(-7);
  return `${start}…${end}`;
};

export default TruncateName;
